import { FaturamentoAntigo } from './faturamento-antigo.model';

export class FaturamentoAntigoVO {

  faturamentoPrincipal: FaturamentoAntigo;
  faturamentoAcimaLimite: FaturamentoAntigo;

}
